import React, { useEffect, useRef, useState } from "react";
import {
  getPayemntGateWay,
  getPaymentProfiles,
  resetPaymentData,
} from "../../../../app/redux/slices/app/paymentSlice";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { CircularProgress } from "@mui/material";

const AddNewPaymentModal = ({ onClose, token, paymentType }) => {
  const popupRef = useRef(null);
  const popupCheckIntervalRef = useRef(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedPaymentMethodType, setSelectedPaymentMethodType] =
    useState("CC");
  const dispatch = useDispatch();
  const { selectedAccount, userAccountDetails } = useSelector(
    (state) => state?.userDetailSlice,
  );
  const { paymentIframDetails: paymentGateWay } = useSelector(
    (state) => state?.payementSlice,
  );

  const PAYMENT_STEPS = {
    GENERATE_PAYMENT_LINK: "GENERATE_PAYMENT_LINK",
    PAYMENT_LINK_LOADED: "PAYMENT_LINK_LOADED",
    CARD_DETAILS_SAVED: "CARD_DETAILS_SAVED",
    CARD_SAVE_FAILED: "CARD_SAVE_FAILED",
  };

  const [paymentStep, setPaymentStep] = useState();
  const iframeUrl = (paymentGateWay?.data || {})[`payment-url`];
  const paymentMethods = [
    { value: "CC", name: "Credit Card", image: "card.png", fee: "2.5%" },
    { value: "DC", name: "Debit Card", image: "card.png", fee: "1%" },
    { value: "DD", name: "E-Check(ACH)", image: "e-check.png", fee: "0%" },
    { value: "AP", name: "Apple Pay", image: "apple-pay.png", fee: "1.8%" },
    { value: "GP", name: "Google Pay", image: "g-pay.png", fee: "1.8%" },
    {
      value: "PAYPAL_ACCOUNT",
      name: "Paypal",
      image: "paypal.png",
      fee: "2.9%",
    },
    { value: "VENMO", name: "Venmo", image: "venmo.png", fee: "2.9%" },
  ];

  const GenerateLinkNewPayment = () => {
    GenerateLink();
  };

  const GenerateLink = (paymentType) => {
    const postBackUrl = `${window.location.origin}/payment/postback`;
    dispatch(
      getPayemntGateWay({
        parent_account_number:
          selectedAccount?.payment_system_profile_id ||
          selectedAccount?.crm_customer_number,
        postback_url: postBackUrl,
        payment_category: paymentType || selectedPaymentMethodType,
        token: token,
        customer_first_name: userAccountDetails?.userAccountInfo?.first_name,
        customer_last_name: userAccountDetails?.userAccountInfo?.last_name,
        customer_email: userAccountDetails?.userAccountInfo?.email_id,
      }),
    );
    setPaymentStep(PAYMENT_STEPS.GENERATE_PAYMENT_LINK);
  };

  const sendMessageToIframe = (e) => {
    setPaymentStep(PAYMENT_STEPS.PAYMENT_LINK_LOADED);
    setTimeout(() => {
      const encodedJson = Cookies.get("paymentPostBackData");
      if (encodedJson) {
        Cookies.remove("paymentPostBackData");
        const decodedJson = decodeURIComponent(encodedJson);
        const jsonObject = JSON.parse(decodedJson);
        if (jsonObject.Token) {
          submitToken(jsonObject);
        } else {
          setPaymentStep(PAYMENT_STEPS.CARD_SAVE_FAILED);
        }
      }
    }, 1000);
  };

  const submitToken = (jsonObject) => {
    setPaymentStep(PAYMENT_STEPS.CARD_DETAILS_SAVED);
    dispatch(
      getPaymentProfiles({
        crm_customer_id:
          selectedAccount?.payment_system_profile_id ||
          selectedAccount?.crm_customer_number,
        crm_service_account_id: selectedAccount?.crm_service_account_number,
        crm_billing_account_id: selectedAccount?.crm_billing_account_number,
        parent_account_number: selectedAccount?.crm_customer_number,
      }),
    );
    setTimeout(() => {
      onClose && onClose();
      setPaymentStep("");
      setSelectedPaymentMethodType("CC");
    }, 2000);
  };

  // Helper function to clear interval safely
  const clearPopupInterval = () => {
    if (popupCheckIntervalRef.current) {
      clearInterval(popupCheckIntervalRef.current);
      popupCheckIntervalRef.current = null;
    }
  };

  // Helper function to close popup safely
  const closePopup = () => {
    if (popupRef.current && !popupRef.current.closed) {
      popupRef.current.close();
      popupRef.current = null;
    }
    setIsPopupOpen(false);
  };

  useEffect(() => {
    if (token) {
      setSelectedPaymentMethodType(paymentType);
      GenerateLink(paymentType);
    }
  }, [token]);

  useEffect(() => {
    if (iframeUrl && selectedPaymentMethodType === "AP") {
      // Clear any existing interval before starting a new one
      clearPopupInterval();

      const popup = window.open(iframeUrl, "iframeTab", "popup");
      popupRef.current = popup;
      setIsPopupOpen(true);

      // Start polling to detect if popup is closed
      popupCheckIntervalRef.current = setInterval(() => {
        const encodedJson = Cookies.get("paymentPostBackData");
        if (encodedJson) {
          // Payment data received
          closePopup();
          clearPopupInterval();

          Cookies.remove("paymentPostBackData");
          const decodedJson = decodeURIComponent(encodedJson);
          const jsonObject = JSON.parse(decodedJson);

          if (jsonObject.Token) {
            submitToken(jsonObject);
          } else {
            setPaymentStep(PAYMENT_STEPS.CARD_SAVE_FAILED);
          }
        } else if (popupRef.current && popupRef.current.closed) {
          // Popup was closed by user
          clearPopupInterval();
          setIsPopupOpen(false);
          popupRef.current = null;
          setPaymentStep("");
        }
      }, 500);
    }

    // Cleanup function for this effect
    return () => {
      clearPopupInterval();
    };
  }, [iframeUrl, selectedPaymentMethodType]);

  // Cleanup on component unmount
  useEffect(() => {
    return () => {
      clearPopupInterval();
      closePopup();
    };
  }, []);

  const handleAppleCancel = () => {
    clearPopupInterval();
    closePopup();
    setPaymentStep("");
  };

  return (
    <>
      <div className="payment-method-modal">
        <div className="modal-body">
          <div className="d-flex align-items-start gap-3">
            {(paymentStep === PAYMENT_STEPS.GENERATE_PAYMENT_LINK ||
              paymentStep === "" ||
              paymentStep === undefined) &&
              !token && (
                <div
                  className="nav flex-column nav-pills gap-2"
                  role="tablist"
                  aria-orientation="vertical"
                >
                  {paymentMethods.map((item) => (
                    <button
                      key={item.value}
                      className={`nav-link ${
                        selectedPaymentMethodType === item.value ? "active" : ""
                      }`}
                      type="button"
                      role="tab"
                      onClick={() => {
                        dispatch(resetPaymentData());
                        setSelectedPaymentMethodType(item.value);
                      }}
                      style={{ textAlign: "left", padding: "12px" }}
                    >
                      <div className="d-flex align-items-center gap-3">
                        <span className="payment-image">
                          <img
                            src={`../images/payment/${item.image}`}
                            alt={item.name}
                            width="36px"
                          />
                        </span>
                        <div>
                          <div className="fw-semibold">{item.name}</div>
                          {/* {item.fee && (
                          <div className="text-muted small mt-1">
                            Processing Fee: &nbsp;{item.fee}
                          </div>
                        )} */}
                        </div>
                      </div>
                      <span className="custom-radio-circle"></span>
                    </button>
                  ))}
                </div>
              )}

            <div className="tab-content flex-grow-1">
              <div
                className="tab-pane fade show active"
                id="v-pills-common"
                role="tabpanel"
              >
                <div className="text-muted">
                  {paymentStep !== "" && (
                    <div className="row cont-centric-c justify-content-center">
                      {paymentStep === PAYMENT_STEPS.GENERATE_PAYMENT_LINK && (
                        <div
                          style={{
                            textAlign: "center",
                            justifyContent: "center",
                            display: "flex",
                            minHeight: "50vh",
                          }}
                        >
                          <div style={{ alignContent: "center" }}>
                            <CircularProgress /> <br />
                            {selectedPaymentMethodType !== "AP" ? (
                              <>Loading payment page...</>
                            ) : (
                              <>
                                Please complete the step in opened window...
                                <div style={{ marginTop: "1rem" }}>
                                  <button
                                    onClick={handleAppleCancel}
                                    className="new_btn active"
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      )}
                      {paymentStep === PAYMENT_STEPS.PAYMENT_LINK_LOADED && (
                        <div
                          style={{
                            textAlign: "center",
                            justifyContent: "center",
                            display: "flex",
                            paddingTop: "10px",
                          }}
                        >
                          <div style={{ alignContent: "center" }}>
                            Please enter payment method details below.
                          </div>
                        </div>
                      )}
                      {paymentStep === PAYMENT_STEPS.CARD_DETAILS_SAVED && (
                        <div
                          style={{
                            textAlign: "center",
                            justifyContent: "center",
                            display: "flex",
                            minHeight: "60vh",
                          }}
                        >
                          <div
                            style={{ alignContent: "center", color: "green" }}
                          >
                            Congratulation!!, card details are saved.
                          </div>
                        </div>
                      )}
                      {paymentStep === PAYMENT_STEPS.CARD_SAVE_FAILED && (
                        <div
                          style={{
                            textAlign: "center",
                            justifyContent: "center",
                            display: "flex",
                            minHeight: "60vh",
                          }}
                        >
                          <div style={{ alignContent: "center" }}>
                            Card save failed, please try again...
                          </div>
                        </div>
                      )}
                      {iframeUrl &&
                        selectedPaymentMethodType !== "AP" &&
                        paymentStep !== PAYMENT_STEPS.CARD_DETAILS_SAVED &&
                        paymentStep !== PAYMENT_STEPS.CARD_SAVE_FAILED && (
                          <div style={{ height: "70vh" }}>
                            <iframe
                              src={iframeUrl}
                              width="100%"
                              height="95%"
                              style={{ overflow: "visible" }}
                              title="paymentUsIFrame"
                              onLoad={() => sendMessageToIframe()}
                            />
                          </div>
                        )}
                    </div>
                  )}
                  {(paymentStep === "" || paymentStep === undefined) && (
                    <div>
                      <div className="payment-note">
                        <div
                          style={{
                            maxWidth: "600px",
                            marginBottom: "26px",
                            fontSize: "14px",
                          }}
                        >
                          {" "}
                          <i>
                            <strong>
                              Credit cards and other digital payment methods may
                              be subject to standard processing fees.
                            </strong>
                            <br />
                            If you prefer to pay electronically without
                            incurring a processing fee, ACH (bank draft) is
                            available at no charge.
                          </i>
                        </div>
                        <div style={{ fontSize: "14px", color: "#555" }}>
                          Please select a payment method and proceed
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="d-flex gap-10px flex-wrap">
        {paymentMethods.map((item) => (
          <div key={item.value}>
            <div className="choice_boxes flex-lg-grow-1" key={item.value}>
              <label
                className={`paymentOption ${
                  selectedPaymentMethodType === item.value ? "selected" : ""
                }`}
              >
                <img src={`images/${item.image}`} alt={item.name} />
                <input
                  type="radio"
                  name="paymentMethod"
                  className="paymentCheckbox"
                  checked={selectedPaymentMethodType === item.value}
                  onChange={() => setSelectedPaymentMethodType(item.value)}
                />
                <span className="checkmark"></span>
              </label>
            </div>
          </div>
        ))}
      </div> */}

      <div className="d-flex justify-content-end gap-10px mt-3">
        {paymentStep !== PAYMENT_STEPS.GENERATE_PAYMENT_LINK &&
          paymentStep !== "" &&
          paymentStep !== undefined &&
          !token && (
            <button
              className="btn btn-custom electric_cobalt"
              onClick={() => {
                setPaymentStep("");
              }}
            >
              <i className="fa-solid fa-arrow-left"></i>
              Back
            </button>
          )}
        {onClose && (
          <button
            className="btn btn-custom startlit_navy"
            data-bs-dismiss="modal"
            onClick={() => {
              setPaymentStep("");
              setSelectedPaymentMethodType("CC");
              onClose && onClose();
            }}
          >
            Cancel
          </button>
        )}

        {(paymentStep === PAYMENT_STEPS.GENERATE_PAYMENT_LINK ||
          paymentStep === "" ||
          paymentStep === undefined) &&
          !token && (
            <button
              disabled={!selectedPaymentMethodType}
              className="btn btn-custom electric_cobalt"
              onClick={GenerateLinkNewPayment}
            >
              Proceed to Add Payment Method
            </button>
          )}
      </div>
    </>
  );
};
export default AddNewPaymentModal;
